import { LISTA_PERMISSOES } from '../util/listaPermissoes'

export const rotasSuporte = [
    {
        path: "/sup",
        name: 'supDashBoard',
        exact: true,
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SUP_ADMIN, LISTA_PERMISSOES.SUP_USUARIO],
        },
        component: () => import('@/views/sup/dashBoard.vue')
    },
    {
        path: "/sup/chamados",
        name: 'ChamadosSuporte',
        exact: true,
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SUP_ADMIN, LISTA_PERMISSOES.SUP_USUARIO],
        },
        component: () => import('@/views/sup/chamados/chamadosListagem.vue')
    },
    {
        path: "/sup/chamados/:id",
        name: 'chamadosEditar',
        meta: {
            abrirDentroDoLayout: true,
            grants: [LISTA_PERMISSOES.MASTER, LISTA_PERMISSOES.SUP_ADMIN, LISTA_PERMISSOES.SUP_USUARIO],
        },
        component: () => import('@/views/sup/chamados/chamadosEditar.vue')
    },

    

]
